















































import Vue from './Mixin'

import { Device, ConfigField } from '@/types/device'
// import ToolbarSave from '@/components/icons/toolbar-save.vue'
// import ToolbarRefresh from '@/components/icons/toolbar-refresh.vue'

export default Vue.extend({
  name: 'DeviceConfig',
  components: {
    // ToolbarSave,
    // ToolbarRefresh,
  },
  props: {
    value: Object,
  },

  data() {
    return {
      model: {} as Device,
      configuration: [] as ConfigField[],
    }
  },

  methods: {
    parseInput() {
      this.model = JSON.parse(JSON.stringify(this.value))
    },

    onToolbarSave() {
      this.patch(this.model.id, this.model)
      this.findDevice()
      // this.$emit('input', JSON.parse(JSON.stringify(this.model)))
    },

    handleReset() {
      this.parseInput()
    },
  },

  watch: {
    value: function(val) {
      this.model = val
      this.configuration = this.drivers[this.model.driver].fields
      // if (JSON.stringify(this.model) !== JSON.stringify(this.value)) {
      //   this.parseInput()
      // }
    },
  },

  created() {
    this.parseInput()
  },
})
